exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-fade-enter-active,.slide-fade-leave-active{transition:all .2s ease}.mydrawer{overflow-y:auto!important;background:rgba(80,80,80,.1)!important;box-shadow:none!important;padding-bottom:0;padding:0;margin:0;height:auto!important}.appicon{cursor:pointer;text-align:center;border-radius:5px;margin:2px;height:66px;width:66px}.appicon:hover,.router-link-active .appicon,.router-link:active .appicon,.router-link:focus .appicon{background:hsla(0,0%,100%,.1)}.router-link{outline:0}.appicon *{padding:15px;font-size:35px}.router-link-active:before{content:\"\";margin-top:29px;margin-left:5px;position:absolute;width:6px;height:6px;border-radius:100%;border:3px solid #e95420}.v-navigation-drawer--close{width:0!important}.v-navigation-drawer{transition:all .1s linear .2s}.menuicon{display:-webkit-inline-box;text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9bd17916","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/partials/SideNav.vue
// module id = 377
// module chunks = 0